import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config;
    if (error.response?.status === 401 && original && !original._retry && original.url?.startsWith("/admin")) {
      original._retry = true;
      refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
      try {
        await refreshing;
        return api(original);
      } catch {
        window.dispatchEvent(new Event("admin-session-expired"));
      }
    }
    return Promise.reject(error);
  }
);

export function errMsg(e, fallback = "Algo deu errado. Tente novamente.") {
  if (!e?.response) return "Falha de conexão. Verifique sua internet e tente novamente.";
  const d = e.response.data?.detail;
  if (!d) return fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return "Há campos inválidos. Revise as informações.";
  if (d.message) return d.message;
  return fallback;
}

export const assetUrl = (path) => (path ? `${BACKEND_URL}${path}` : null);
